import Tracker, { SanitizeLevel } from '@openreplay/tracker';

interface RequestData {
  body: string | null
  headers: Record<string, string>
}
import type { Mixpanel } from 'mixpanel-browser';

interface ResponseData {
  body: any
  headers: Record<string, string>
}
export interface RequestResponseData {
  readonly status: number
  readonly method: string
  url: string
  request: RequestData
  response: ResponseData
}

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const tracker = new Tracker({
    connAttemptGap: 0,
    __DISABLE_SECURE_MODE: !!runtimeConfig.public.IS_LOCAL_HOST,
    projectKey: runtimeConfig.public.OPEN_REPLAY,
    ingestPoint: 'https://repl.kegel-plan.com/ingest',
    mouse: {
      disableClickmaps: true,
    },
    network: {
      capturePayload: true,
      useProxy: true,
      failuresOnly: false,
      sessionTokenHeader: false,
      tokenUrlMatcher: undefined,
      ignoreHeaders: true,
      captureInIframes: true,
      axiosInstances: undefined,
      sanitizer: (data: RequestResponseData) => {
        return data;
      },
    },
    domSanitizer: (node: Element) => {
      const elementClassNames = node.classList;

      if (elementClassNames.contains('sensitive_content')) {
        return SanitizeLevel.Hidden;
      }

      return SanitizeLevel.Plain;
    },
  });
  function startCallback() {
    const replaySessionId = tracker.getSessionID();

    (nuxtApp.$mixpanel as Mixpanel).people.set({
      'Rplay ID': replaySessionId,
      'Rplay URL': tracker.getSessionURL(),
    });
  }

  tracker.start().then(() => {
    startCallback();
  });

  return {
    provide: {
      tracker,
    },
  };
});
